import React from "react";
import Header from "../components/layout/Header";
import ProfileContainer from "../components/profile/ProfileContainer";

const Profile = () => {
  return (
    <div>
      <Header />
      <ProfileContainer />
    </div>
  );
};

export default Profile;
